// Toasts are rendered inside the page, but fixed elements inside content blocks end up in their stacking
// contexts and slip behind later sections. All toasts are therefore moved into one container on <body>,
// which also stacks them, animates them in and out and hides them again after data-autohide milliseconds.
const STACK_ID = 'app-toast-stack';
const LEAVING_CLASS = 'is-leaving';

function getStack() {
    let stack = document.getElementById(STACK_ID);

    if (!stack) {
        stack = document.createElement('div');
        stack.id = STACK_ID;
        stack.className = 'toast-container app-toast-container position-fixed end-0 p-3 d-none d-lg-flex flex-column gap-2';
        document.body.appendChild(stack);
    }

    return stack;
}

function dismiss(toast) {
    if (toast.classList.contains(LEAVING_CLASS)) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        toast.remove();

        return;
    }

    toast.classList.add(LEAVING_CLASS);
    toast.addEventListener('animationend', () => toast.remove(), {once: true});
}

export default function initToasts() {
    const toasts = document.querySelectorAll('.app-toast');

    if (!toasts.length) {
        return;
    }

    const stack = getStack();

    toasts.forEach((toast) => {
        const container = toast.closest('.app-toast-container');

        stack.appendChild(toast);
        container?.remove();

        // Stop the click here so Bootstrap's delegated data-api does not hide the toast without the exit animation.
        toast.querySelector('[data-bs-dismiss="toast"]')?.addEventListener('click', (event) => {
            event.stopPropagation();
            dismiss(toast);
        });

        const autohide = Number(toast.dataset.autohide);
        if (autohide > 0) {
            window.setTimeout(() => dismiss(toast), autohide);
        }
    });
}
